import { Icon } from './Icon'

export type PageKey = 'dashboard' | 'nodes' | 'resources' | 'services' | 'domains' | 'terminal' | 'docs'

const items: { key: PageKey; label: string; icon: string; hint: string }[] = [
  { key: 'dashboard', label: '总览', icon: 'dashboard', hint: '资源与额度态势' },
  { key: 'resources', label: '云资源', icon: 'cloud', hint: '六大云与自建资源' },
  { key: 'services', label: '智能分流', icon: 'route', hint: '云优先与本地兜底' },
  { key: 'nodes', label: '服务器', icon: 'server', hint: '节点、容量与能力' },
  { key: 'domains', label: '域名', icon: 'globe', hint: 'DNS · Nginx · TLS' },
  { key: 'terminal', label: '终端', icon: 'terminal', hint: '安全任务与审计' },
  { key: 'docs', label: '接入', icon: 'docs', hint: 'API、Agent 与 Gateway' },
]

export function Sidebar({ page, onChange, open, onClose }: { page: PageKey; onChange: (page: PageKey) => void; open: boolean; onClose: () => void }) {
  return <>
    <aside className={`sidebar ${open ? 'sidebar-open' : ''}`}>
      <div className="brand">
        <div className="brand-mark" aria-hidden="true"><span /><span /><span /></div>
        <div><strong>天天面板</strong><small>TianCloud Orchestrator</small></div>
        <button className="sidebar-close icon-button" onClick={onClose} aria-label="关闭导航"><Icon name="x" /></button>
      </div>
      <div className="sidebar-caption">CONTROL CENTER</div>
      <nav className="sidebar-nav" aria-label="主导航">
        {items.map((item) => <button key={item.key} className={page === item.key ? 'active' : ''} onClick={() => { onChange(item.key); onClose() }}>
          <span className="nav-icon"><Icon name={item.icon} /></span>
          <span><strong>{item.label}</strong><small>{item.hint}</small></span>
          <Icon name="chevron" size={16} className="nav-chevron" />
        </button>)}
      </nav>
      <div className="sidebar-bottom">
        <div className="hub-health-plain"><span className="live-dot" />Hub 服务正常</div>
        <div className="sidebar-version">TianCloud · Internal Control Plane</div>
      </div>
    </aside>
    {open && <button className="sidebar-scrim" aria-label="关闭导航" onClick={onClose} />}
  </>
}
